// extracted by mini-css-extract-plugin
export default {"base":"Breadcrumbs_base__FYBr1"};